<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';

  const LIMITE_BUSCA = 200;
  const DIAS_SEM_CLIENTE = 90;

  export default {
    components: { DatePicker },
    props: {
      value: { type: Object, default: null },
      idPessoa: { type: Number, default: 0 },
      nomePessoa: { type: String, default: '' },
      total: { type: Number, default: 0 },
      criaContaReceber: { type: Boolean, default: true },
      idsProjeto: { type: Array, default: () => [] },
      sugestoes: { type: Array, default: () => [] },
      multipla: { type: Boolean, default: false },
      notasMarcadas: { type: Array, default: () => [] },
      permitirOutroCliente: { type: Boolean, default: false },
    },
    data() {
      return {
        aberto: false,
        carregando: false,
        erro: '',
        lista: null,
        escolhida: null,
        marcadas: [],
        confirmando: false,
        detalhe: null,
        carregandoDetalhe: false,
        erroDetalhe: '',
        filtro: this.filtroInicial(),
        temporizador: null,
        pedido: 0,
        pedidoDetalhe: 0,
      }
    },
    computed: {
      sugestoesBusca() {
        const lista = [];
        (this.sugestoes || []).forEach(s => {
          const t = (s || '').trim();
          if (t && !lista.some(x => x.toUpperCase() === t.toUpperCase())) lista.push(t);
        });
        return lista;
      },
      projetos() {
        return (this.idsProjeto || []).filter(id => +id > 0).filter((id, i, a) => a.indexOf(id) === i);
      },
      noLimite() { return (this.lista || []).length >= LIMITE_BUSCA; },
      valorFiltro() {
        const texto = (this.filtro.valorTexto || '').trim();
        if (!texto) return 0;
        const numero = +texto.replace(/\./g, '').replace(',', '.');
        return isNaN(numero) ? 0 : numero;
      },
      valorTotalAtivo() { return !!this.valorFiltro && Math.abs(this.valorFiltro - this.total) < 0.005; },
      filtroAtivo() {
        const f = this.filtro;
        return !!(f.busca.trim() || f.dataIni || f.dataFim || this.valorFiltro || !f.somenteSemContaReceber);
      },
      outroCliente() {
        if (this.multipla || this.permitirOutroCliente) return false;
        return !!(this.escolhida && this.idPessoa > 0 && this.escolhida.idPessoa > 0 && this.escolhida.idPessoa !== this.idPessoa);
      },
      somaMarcadas() {
        return Math.round(this.marcadas.reduce((s, nf) => s + (+nf.valor || 0), 0) * 100) / 100;
      },
      faltaMarcadas() { return Math.round((this.total - this.somaMarcadas) * 100) / 100; },
      podeConfirmar() {
        if (this.multipla) return this.marcadas.length > 0 || this.notasMarcadas.length > 0;
        return !!this.escolhida && !this.outroCliente;
      },
      jaTemContaReceber() {
        return !!(this.value && +this.value.qtdeContasReceber > 0);
      },
      diferencaValor() {
        if (!this.value || !this.total) return 0;
        return Math.round((this.total - (+this.value.valor || 0)) * 100) / 100;
      },
    },
    watch: {
      filtro: {
        deep: true,
        handler() {
          if (!this.aberto) return;
          clearTimeout(this.temporizador);
          this.temporizador = setTimeout(() => this.buscar(), 400);
        },
      },
      idPessoa(novo) {
        if (this.value && novo > 0 && this.value.idPessoa > 0 && this.value.idPessoa !== novo)
          this.$emit('input', null);
      },
    },
    beforeDestroy() {
      clearTimeout(this.temporizador);
    },
    methods: {
      filtroInicial() {
        const comCliente = this.idPessoa > 0;
        const comProjeto = (this.idsProjeto || []).some(id => +id > 0);
        const busca = comCliente ? '' : ((this.sugestoes || []).map(s => (s || '').trim()).filter(s => !!s)[0] || '');
        return {
          busca,
          soDoCliente: comCliente,
          soDosProjetos: comProjeto,
          dataIni: comCliente || comProjeto || busca ? null : moment().subtract(DIAS_SEM_CLIENTE, 'days').toDate(),
          dataFim: null,
          valorTexto: '',
          somenteSemContaReceber: true,
        };
      },
      formatar(v) {
        return (+v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      abrir() {
        this.lista = null;
        this.erro = '';
        this.detalhe = null;
        this.escolhida = this.value ? Object.assign({}, this.value) : null;
        this.marcadas = (this.notasMarcadas || []).map(nf => Object.assign({}, nf));
        if (this.multipla && !this.escolhida && this.marcadas.length) this.escolhida = this.marcadas[0];
        this.filtro = this.filtroInicial();
        this.aberto = true;
        this.buscar();
        if (this.escolhida) this.carregarDetalhe(this.escolhida);
        this.$nextTick(() => this.$refs.busca && this.$refs.busca.focus());
      },
      fechar() {
        clearTimeout(this.temporizador);
        this.aberto = false;
      },
      limparFiltros() {
        this.filtro = Object.assign(this.filtroInicial(),
          { busca: '', dataIni: null, soDoCliente: this.filtro.soDoCliente, soDosProjetos: this.filtro.soDosProjetos });
      },
      alternarValorTotal() {
        this.filtro.valorTexto = this.valorTotalAtivo ? '' : this.formatar(this.total);
      },
      sugestaoAtiva(s) {
        return this.filtro.busca.trim().toUpperCase() === s.toUpperCase();
      },
      alternarSugestao(s) {
        this.filtro.busca = this.sugestaoAtiva(s) ? '' : s;
      },
      buscarAgora() {
        clearTimeout(this.temporizador);
        this.buscar();
      },
      enterNoFiltro(e) {
        if (!e.target || e.target.tagName !== 'INPUT') return;
        e.preventDefault();
        e.stopPropagation();
        this.buscarAgora();
      },
      buscar() {
        const pedido = ++this.pedido;
        const f = this.filtro;

        this.carregando = true;
        this.erro = '';

        conciliacaoProjetoServico.notasFiscais({
          idPessoa: f.soDoCliente && this.idPessoa > 0 ? this.idPessoa : 0,
          busca: f.busca.trim(),
          dataIni: f.dataIni ? moment(f.dataIni).format('YYYY-MM-DD') : '',
          dataFim: f.dataFim ? moment(f.dataFim).format('YYYY-MM-DD') : '',
          valor: this.valorFiltro ? this.valorFiltro.toFixed(2) : '',
          somenteSemContaReceber: f.somenteSemContaReceber,
          idsProjeto: this.projetos.join(','),
          somenteDosProjetos: f.soDosProjetos && this.projetos.length > 0,
        })
          .then(lista => {
            if (pedido !== this.pedido) return;
            this.carregando = false;
            this.lista = lista || [];
          })
          .catch(res => {
            if (pedido !== this.pedido) return;
            this.carregando = false;
            this.erro = (res && res.body && res.body.message) || 'Não foi possível buscar as notas fiscais.';
          });
      },
      escolher(nf) {
        this.escolhida = nf;
        this.carregarDetalhe(nf);
      },
      ehMarcada(nf) {
        return this.marcadas.some(m => m.idNotaFiscal === nf.idNotaFiscal);
      },
      alternarMarcada(nf) {
        const indice = this.marcadas.findIndex(m => m.idNotaFiscal === nf.idNotaFiscal);
        if (indice >= 0) this.marcadas.splice(indice, 1);
        else this.marcadas.push(nf);
        this.escolher(nf);
      },
      rotuloSugestao(s) {
        return /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}$/i.test(s) ? 'Mesmo grupo do CNPJ: ' : 'Do extrato: ';
      },
      confirmarVarias() {
        this.confirmando = true;

        Promise.all(this.marcadas.map(nf => conciliacaoProjetoServico.notaFiscal(nf.idNotaFiscal)
          .then(detalhe => Object.assign({}, nf, detalhe || {}))))
          .then(notas => {
            this.confirmando = false;
            const comCr = notas.filter(nf => +nf.qtdeContasReceber > 0);

            if (!comCr.length) {
              this.$emit('escolhidas', notas);
              this.fechar();
              return;
            }

            this.$swal({
              title: 'Notas fiscais com contas a receber',
              text: comCr.map(nf => nf.numero + ' (' + nf.qtdeContasReceber + ')').join(', ')
                  + ' já ' + (comCr.length > 1 ? 'têm' : 'tem') + ' contas a receber. Ao gravar, cada uma fica com mais um, '
                  + 'e o cliente pode aparecer cobrado em dobro. Se o recebimento é dessas NFs, o caminho costuma ser baixar o CR '
                  + 'que já existe. Deseja vincular mesmo assim?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Sim, vincular',
              cancelButtonText: 'Cancelar',
            })
              .then(result => {
                if (!(result === true || (result && result.value))) return;
                this.$emit('escolhidas', notas);
                this.fechar();
              })
              .catch(() => {});
          })
          .catch(res => {
            this.confirmando = false;
            this.erro = (res && res.body && res.body.message) || 'Não foi possível carregar as notas fiscais escolhidas.';
          });
      },
      carregarDetalhe(nf) {
        const pedido = ++this.pedidoDetalhe;

        this.carregandoDetalhe = true;
        this.erroDetalhe = '';
        this.detalhe = null;

        conciliacaoProjetoServico.notaFiscal(nf.idNotaFiscal)
          .then(detalhe => {
            if (pedido !== this.pedidoDetalhe) return;
            this.carregandoDetalhe = false;
            this.detalhe = detalhe;
          })
          .catch(res => {
            if (pedido !== this.pedidoDetalhe) return;
            this.carregandoDetalhe = false;
            this.erroDetalhe = (res && res.body && res.body.message) || 'Não foi possível carregar a nota fiscal.';
          });
      },
      ehEscolhida(nf) {
        return !!(this.escolhida && this.escolhida.idNotaFiscal === nf.idNotaFiscal);
      },
      projetoDe(nf) {
        if (!nf.nomeProjeto) return '';
        return nf.qtdeProjetos > 1 ? nf.nomeProjeto + ' (+' + (nf.qtdeProjetos - 1) + ')' : nf.nomeProjeto;
      },
      confirmar() {
        if (this.multipla) {
          this.confirmarVarias();
          return;
        }

        if (!this.escolhida || this.outroCliente) return;

        const nf = Object.assign({}, this.escolhida, this.detalhe || {});
        const qtde = +nf.qtdeContasReceber || 0;

        if (!this.criaContaReceber || qtde === 0) {
          this.concluir(nf);
          return;
        }

        this.$swal({
          title: 'Nota fiscal com contas a receber',
          text: 'A ' + nf.numero + ' já tem ' + qtde + ' contas a receber vinculado' + (qtde > 1 ? 's' : '')
              + '. Ao gravar, ela fica com mais um, e o cliente pode aparecer cobrado em dobro. '
              + 'Se o recebimento é dessa NF, o caminho costuma ser baixar o CR que já existe. Deseja vincular mesmo assim?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, vincular',
          cancelButtonText: 'Cancelar',
        })
          .then(result => {
            if (!(result === true || (result && result.value))) return;
            this.concluir(nf);
          })
          .catch(() => {});
      },
      concluir(nf) {
        if (nf.idPessoa > 0 && (!(this.idPessoa > 0) || (this.permitirOutroCliente && nf.idPessoa !== this.idPessoa))) {
          const documento = (nf.cpfcnpj || '').replace(/[^A-Za-z0-9]/g, '');
          this.$emit('cliente', { idPessoa: nf.idPessoa, nomePessoa: nf.nomePessoa, tipoPessoa: documento.length === 11 ? 1 : 2 });
        }
        if ((nf.rateios || []).length) this.$emit('rateios', nf.rateios);
        this.$emit('input', nf);
        this.fechar();
      },
      remover() {
        this.$emit('input', null);
      },
    },
  }
</script>

<template>
  <div class="nfv">
    <div v-if="multipla" class="nfv-vazio">
      <button type="button" class="nfv-botao" @click="abrir">
        <i class="fa fa-files-o"></i> {{ notasMarcadas.length ? 'Trocar as notas fiscais' : 'Escolher notas fiscais' }}
      </button>
      <small v-if="notasMarcadas.length">{{ notasMarcadas.length }} nota{{ notasMarcadas.length > 1 ? 's' : '' }} vinculada{{ notasMarcadas.length > 1 ? 's' : '' }} — cada nota vira um título abaixo.</small>
      <small v-else>Marque uma ou mais notas: cada uma vira um título, com cliente, valor e rateio da nota.</small>
    </div>

    <div v-else-if="!value" class="nfv-vazio">
      <button type="button" class="nfv-botao" @click="abrir">
        <i class="fa fa-file-text-o"></i> Vincular nota fiscal
      </button>
      <small>Ao escolher a NF, o cliente e o rateio vêm dela. O lançamento fica ligado à nota.</small>
    </div>

    <div v-else class="nfv-card">
      <div class="nfv-card-txt">
        <div class="nfv-l1">
          <b class="mono">{{ value.numero }}</b>
          <span class="nfv-nome" :title="value.nomePessoa">{{ value.nomePessoa || 'Sem cliente' }}</span>
          <span class="nfv-valor mono">R$ {{ formatar(value.valor) }}</span>
        </div>
        <div class="nfv-l2">
          <span><i class="fa fa-calendar"></i> Emissão {{ value.dataEmissaoStr || '—' }}</span>
          <span v-if="value.dataVencimentoStr">Venc. {{ value.dataVencimentoStr }}</span>
          <span v-if="value.numeroRPS" class="mono">RPS {{ value.numeroRPS }}</span>
          <span v-if="value.nomeProjeto" class="nfv-proj" :title="value.nomeProjeto">{{ projetoDe(value) }}</span>
        </div>
        <div v-if="value.complemento" class="nfv-compl" :title="value.complemento">{{ value.complemento }}</div>
        <div v-if="jaTemContaReceber && criaContaReceber" class="nfv-alerta">
          <i class="fa fa-exclamation-triangle"></i>
          Esta NF já tem {{ value.qtdeContasReceber }} contas a receber. O novo fica somado a ele{{ value.qtdeContasReceber > 1 ? 's' : '' }}.
        </div>
        <div v-else-if="diferencaValor !== 0" class="nfv-aviso">
          Valor da NF difere do lançamento em R$ {{ formatar(Math.abs(diferencaValor)) }}.
        </div>
      </div>
      <div class="nfv-card-acoes">
        <button type="button" class="nfv-mini" title="Trocar a nota fiscal" @click="abrir"><i class="fa fa-exchange"></i></button>
        <button type="button" class="nfv-mini nfv-mini-remover" title="Desvincular" @click="remover"><i class="fa fa-times"></i></button>
      </div>
    </div>

    <div v-if="aberto" class="nfv-back">
      <div class="nfv-modal">
        <div class="nfv-cab">
          <h4><i class="fa fa-file-text-o"></i> {{ multipla ? 'Escolher notas fiscais' : 'Escolher nota fiscal' }}</h4>
          <small v-if="multipla">Marque as notas que este crédito paga — a soma aparece no rodapé. Ficam de fora as canceladas.</small>
          <small v-else>Escolha uma nota. Ficam de fora as canceladas. Clique na linha para ver os detalhes da NF.</small>
        </div>

        <div class="nfv-filtros" @keydown.enter="enterNoFiltro">
          <div class="nfv-filtro nfv-filtro-lg">
            <label>Número, RPS, complemento ou cliente</label>
            <div class="nfv-busca-linha">
              <input ref="busca" type="text" class="form-control" v-model="filtro.busca" maxlength="100" placeholder="Número, cliente ou CNPJ">
              <button type="button" class="btn btn-success no-margins" :disabled="carregando" @click="buscarAgora" title="Buscar agora (Enter)">
                <i class="fa" :class="carregando ? 'fa-spinner fa-pulse' : 'fa-search'"></i> Buscar
              </button>
            </div>
          </div>
          <div class="nfv-filtro nfv-filtro-sm">
            <label>Emissão de</label>
            <date-picker v-model="filtro.dataIni" format="DD/MM/YYYY" lang="pt-br" input-class="form-control" placeholder="Selecione"
                         :editable="false" :shortcuts="false" :append-to-body="true"
                         :popup-style="{ zIndex: 3600 }" style="width:100%"></date-picker>
          </div>
          <div class="nfv-filtro nfv-filtro-sm">
            <label>até</label>
            <date-picker v-model="filtro.dataFim" format="DD/MM/YYYY" lang="pt-br" input-class="form-control" placeholder="Selecione"
                         :editable="false" :shortcuts="false" :append-to-body="true"
                         :popup-style="{ zIndex: 3600 }" style="width:100%"></date-picker>
          </div>
          <div class="nfv-filtro nfv-filtro-sm">
            <label>Valor</label>
            <input type="text" class="form-control mono" v-model="filtro.valorTexto" maxlength="20" placeholder="0,00">
          </div>
          <div class="nfv-chips">
            <label v-if="idPessoa > 0" class="nfv-check">
              <input type="checkbox" v-model="filtro.soDoCliente"> Só de {{ nomePessoa || 'cliente escolhido' }}
            </label>
            <label v-if="projetos.length" class="nfv-check">
              <input type="checkbox" v-model="filtro.soDosProjetos"> Só {{ projetos.length > 1 ? 'dos projetos' : 'do projeto' }} do rateio
            </label>
            <label class="nfv-check">
              <input type="checkbox" v-model="filtro.somenteSemContaReceber"> Só sem contas a receber
            </label>
            <button v-if="total" type="button" class="nfv-chip" :class="{ ativo: valorTotalAtivo }" @click="alternarValorTotal">
              <i v-if="valorTotalAtivo" class="fa fa-check"></i> Valor da operação R$ {{ formatar(total) }}
            </button>
            <button v-for="s in sugestoesBusca" :key="'sug-' + s" type="button" class="nfv-chip" :class="{ ativo: sugestaoAtiva(s) }" @click="alternarSugestao(s)">
              <i v-if="sugestaoAtiva(s)" class="fa fa-check"></i> {{ rotuloSugestao(s) }}{{ s }}
            </button>
            <button v-if="filtroAtivo" type="button" class="nfv-chip nfv-chip-limpar" @click="limparFiltros">
              <i class="fa fa-eraser"></i> Limpar filtros
            </button>
          </div>
        </div>

        <div class="nfv-corpo">
          <div class="nfv-lista">
            <div v-if="carregando && !lista" class="nfv-info"><i class="fa fa-spinner fa-pulse"></i> Buscando as notas fiscais...</div>
            <div v-else-if="erro" class="nfv-info nfv-erro">{{ erro }}</div>
            <div v-else-if="lista && !lista.length" class="nfv-info">Nenhuma nota fiscal com esses filtros.</div>
            <template v-else-if="lista">
              <div v-if="noLimite" class="nfv-limite"><i class="fa fa-info-circle"></i> Mostrando as {{ lista.length }} mais recentes. Refine os filtros para achar a nota.</div>
              <table class="nfv-tab" :class="{ 'nfv-tab-carregando': carregando }">
                <thead>
                  <tr>
                    <th></th>
                    <th>Número</th>
                    <th>Emissão</th>
                    <th>Cliente / Projeto</th>
                    <th>Complemento</th>
                    <th class="nfv-dir">Valor</th>
                    <th title="Contas a receber vinculados">CR</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="nf in lista" :key="nf.idNotaFiscal" :class="{ on: ehEscolhida(nf), marcada: multipla && ehMarcada(nf) }"
                      @click="multipla ? alternarMarcada(nf) : escolher(nf)">
                    <td v-if="multipla"><input type="checkbox" :checked="ehMarcada(nf)" @click.stop="alternarMarcada(nf)"></td>
                    <td v-else><input type="radio" :checked="ehEscolhida(nf)" @click.stop="escolher(nf)"></td>
                    <td class="mono nfv-nowrap">
                      {{ nf.numero }}
                      <small v-if="nf.numeroRPS" class="nfv-sub">RPS {{ nf.numeroRPS }}</small>
                    </td>
                    <td class="mono nfv-nowrap">
                      {{ nf.dataEmissaoStr }}
                      <small v-if="nf.dataVencimentoStr" class="nfv-sub">venc. {{ nf.dataVencimentoStr }}</small>
                    </td>
                    <td class="nfv-cel-nome">
                      <div :title="nf.nomePessoa">{{ nf.nomePessoa || '—' }}</div>
                      <small v-if="nf.nomeProjeto" :title="nf.nomeProjeto">
                        <i v-if="nf.projetoConfere && projetos.length" class="fa fa-check-circle nfv-proj-ok" title="Projeto do rateio"></i>
                        {{ projetoDe(nf) }}
                      </small>
                    </td>
                    <td class="nfv-cel-compl"><div :title="nf.complemento">{{ nf.complemento || '—' }}</div></td>
                    <td class="mono nfv-dir">{{ formatar(nf.valor) }}</td>
                    <td>
                      <span v-if="nf.qtdeContasReceber > 0" class="nfv-tag nfv-tag-cr" :title="nf.qtdeContasReceber + ' contas a receber'">
                        <i class="fa fa-circle"></i> {{ nf.qtdeContasReceber }}
                      </span>
                      <span v-else class="nfv-tag nfv-tag-sem">sem</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>

          <div class="nfv-detalhe">
            <div v-if="!escolhida" class="nfv-info">Clique numa nota para ver os detalhes.</div>
            <div v-else-if="carregandoDetalhe" class="nfv-info"><i class="fa fa-spinner fa-pulse"></i> Carregando a nota...</div>
            <div v-else-if="erroDetalhe" class="nfv-info nfv-erro">{{ erroDetalhe }}</div>
            <template v-else-if="detalhe">
              <div class="nfv-det-cab">
                <b class="mono">{{ detalhe.numero }}</b>
                <span class="mono">R$ {{ formatar(detalhe.valor) }}</span>
              </div>
              <dl class="nfv-dl">
                <dt>Cliente</dt>
                <dd>{{ detalhe.nomePessoa || '—' }}<small v-if="detalhe.cpfcnpj" class="mono"> · {{ detalhe.cpfcnpj }}</small></dd>
                <dt>Emissão</dt>
                <dd class="mono">{{ detalhe.dataEmissaoStr || '—' }}<template v-if="detalhe.dataVencimentoStr"> · venc. {{ detalhe.dataVencimentoStr }}</template></dd>
                <template v-if="detalhe.numeroRPS"><dt>RPS</dt><dd class="mono">{{ detalhe.numeroRPS }}</dd></template>
                <template v-if="detalhe.naturezaOperacao"><dt>Natureza</dt><dd>{{ detalhe.naturezaOperacao }}</dd></template>
                <template v-if="detalhe.contrato"><dt>Contrato</dt><dd>{{ detalhe.contrato }}</dd></template>
                <template v-if="detalhe.complemento"><dt>Complemento</dt><dd>{{ detalhe.complemento }}</dd></template>
                <template v-if="detalhe.observacao && detalhe.observacao.trim().length > 1"><dt>Observação</dt><dd class="nfv-obs">{{ detalhe.observacao }}</dd></template>
              </dl>

              <div v-if="detalhe.rateios.length" class="nfv-secao">
                <h5>Projetos</h5>
                <div v-for="(r, i) in detalhe.rateios" :key="'r' + i" class="nfv-linha">
                  <span class="nfv-linha-txt" :title="r.nomeProjeto">{{ r.nomeProjeto }}</span>
                  <span class="mono">{{ formatar(r.valor) }}</span>
                </div>
              </div>

              <div class="nfv-secao">
                <h5>Contas a receber desta NF</h5>
                <div v-if="!detalhe.contasReceber.length" class="nfv-sem-cr">Nenhum contas a receber vinculado.</div>
                <div v-for="c in detalhe.contasReceber" :key="c.idLancamento" class="nfv-cr">
                  <div class="nfv-linha">
                    <span class="nfv-linha-txt"><b>CR {{ c.idLancamento }}</b> <span class="mono">{{ c.documento }}</span></span>
                    <span class="mono">{{ formatar(c.valor) }}</span>
                  </div>
                  <div class="nfv-cr-l2">
                    <span :class="c.baixado ? 'nfv-tag nfv-tag-baixado' : 'nfv-tag nfv-tag-aberto'">{{ c.baixado ? 'Baixado ' + c.dataBaixaStr : 'Em aberto' }}</span>
                    <span v-if="c.dataVencimentoStr" class="mono">venc. {{ c.dataVencimentoStr }}</span>
                    <span v-if="c.nomeConta" class="nfv-linha-txt" :title="c.nomeConta">{{ c.nomeConta }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="nfv-rodape">
          <span v-if="multipla && marcadas.length" class="nfv-cont" :class="Math.abs(faltaMarcadas) < 0.005 ? 'nfv-bate' : 'nfv-ok'">
            {{ marcadas.length }} nota{{ marcadas.length > 1 ? 's' : '' }} · R$ {{ formatar(somaMarcadas) }}
            <template v-if="total && Math.abs(faltaMarcadas) < 0.005"> · bate com o crédito</template>
            <template v-else-if="total && faltaMarcadas > 0"> · faltam R$ {{ formatar(faltaMarcadas) }}</template>
            <template v-else-if="total"> · passou R$ {{ formatar(-faltaMarcadas) }}</template>
          </span>
          <span v-else-if="multipla" class="nfv-cont">Nenhuma nota marcada</span>
          <span v-else-if="outroCliente" class="nfv-cont nfv-falta">
            <i class="fa fa-ban"></i> Esta NF é de {{ escolhida.nomePessoa || 'outro cliente' }}, não de {{ nomePessoa || 'cliente escolhido' }}.
          </span>
          <span v-else-if="escolhida" class="nfv-cont nfv-ok">{{ escolhida.numero }} · R$ {{ formatar(escolhida.valor) }}</span>
          <span v-else class="nfv-cont">Nenhuma nota escolhida</span>
          <button type="button" class="btn btn-primary" :disabled="!podeConfirmar || carregandoDetalhe || confirmando" @click="confirmar">
            <i class="fa" :class="confirmando ? 'fa-spinner fa-pulse' : 'fa-link'"></i>
            {{ multipla ? (marcadas.length > 1 ? 'Vincular ' + marcadas.length + ' notas' : marcadas.length ? 'Vincular nota fiscal' : notasMarcadas.length ? 'Desvincular as notas' : 'Vincular notas fiscais') : 'Vincular nota fiscal' }}
          </button>
          <button type="button" class="nfv-sair" @click="fechar"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; }
  .nfv { margin: 0; }
  .nfv-vazio { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 10px; }
  .nfv-vazio small { color: #8a939c; font-size: 11.5px; }
  .nfv-botao { height: 28px; padding: 0 11px; background: #fff; border: 1px solid #2b6cb0; border-radius: 5px; font-size: 12px; font-weight: 600; color: #2b6cb0; }
  .nfv-botao:hover { background: #eef4fb; }
  .nfv-card { display: flex; gap: 10px; align-items: flex-start; border: 1px solid #d6e3f2; background: #f5f9fd; border-radius: 6px; padding: 8px 10px; }
  .nfv-card-txt { flex: 1 1 auto; min-width: 0; }
  .nfv-l1 { display: flex; gap: 10px; align-items: baseline; font-size: 13px; color: #1c2024; min-width: 0; }
  .nfv-nome { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .nfv-valor { flex: none; font-weight: 600; }
  .nfv-l2 { display: flex; flex-wrap: wrap; gap: 4px 14px; font-size: 11.5px; color: #6b747e; margin-top: 2px; }
  .nfv-l2 .fa { color: #9aa3ac; }
  .nfv-proj { max-width: 260px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .nfv-compl { font-size: 11.5px; color: #8a939c; margin-top: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .nfv-alerta { margin-top: 6px; font-size: 11.5px; font-weight: 600; color: #8a5a00; background: #fdf3e1; border-radius: 4px; padding: 4px 8px; }
  .nfv-aviso { margin-top: 6px; font-size: 11.5px; color: #6b747e; }
  .nfv-card-acoes { flex: none; display: flex; gap: 4px; }
  .nfv-mini { width: 26px; height: 26px; border: 1px solid #d3d8de; border-radius: 4px; background: #fff; color: #5b6570; }
  .nfv-mini:hover { background: #eef4fb; border-color: #2b6cb0; color: #2b6cb0; }
  .nfv-mini-remover:hover { background: #fbeaea; border-color: #e5b5b5; color: #a13c3c; }

  .nfv-back { position: fixed; inset: 0; background: rgba(16,24,40,.5); z-index: 3400; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .nfv-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); width: 100%; max-width: 1180px; max-height: 92vh; display: flex; flex-direction: column; }
  .nfv-cab { padding: 16px 20px 12px; border-bottom: 1px solid #e6eaee; flex: 0 0 auto; }
  .nfv-cab h4 { margin: 0 0 3px; font-size: 17px; font-weight: 600; color: #1c2024; }
  .nfv-cab small { color: #8a939c; font-size: 12.5px; }
  .nfv-filtros { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 10px; padding: 12px 20px; border-bottom: 1px solid #eef1f4; background: #fafbfc; flex: 0 0 auto; }
  .nfv-filtro { display: flex; flex-direction: column; flex: 1 1 130px; min-width: 0; }
  .nfv-filtro-lg { flex: 3 1 260px; }
  .nfv-filtro-sm { flex: 0 1 140px; }
  .nfv-filtro label { font-size: 11.5px; font-weight: 600; color: #4b545e; margin-bottom: 3px; }
  .nfv-filtro .form-control { height: 32px; font-size: 12.5px; }
  .nfv-busca-linha { display: flex; gap: 6px; }
  .nfv-busca-linha .form-control { flex: 1 1 auto; min-width: 0; }
  .nfv-busca-linha .btn { height: 32px; padding: 0 12px; font-size: 12.5px; flex: 0 0 auto; }
  .nfv-chips { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 12px; flex: 1 1 100%; }
  .nfv-check { display: inline-flex; align-items: center; gap: 5px; margin: 0; font-size: 12.5px; font-weight: 600; color: #4b545e; cursor: pointer; }
  .nfv-check input { margin: 0; }
  .nfv-chip { height: 28px; padding: 0 10px; border: 1px dashed #b9c3cd; border-radius: 14px; background: #fff; color: #2b6cb0; font-size: 12px; font-weight: 600; }
  .nfv-chip:hover { background: #f1f5f9; border-color: #2b6cb0; }
  .nfv-chip.ativo { border-style: solid; border-color: #0f8a5f; background: #e8f5ef; color: #0a6d4d; }
  .nfv-chip-limpar { color: #5b6570; }
  .nfv-corpo { display: flex; flex: 1 1 auto; min-height: 280px; overflow: hidden; }
  .nfv-lista { flex: 1 1 auto; min-width: 0; overflow: auto; padding: 12px 16px 12px 20px; }
  .nfv-detalhe { flex: 0 0 330px; overflow: auto; padding: 12px 20px 12px 16px; border-left: 1px solid #eef1f4; background: #fbfcfd; }
  .nfv-info { padding: 28px 10px; text-align: center; color: #8a939c; font-size: 13px; }
  .nfv-erro { color: #a13c3c; }
  .nfv-limite { font-size: 12px; color: #8a5a00; background: #fffaf0; border: 1px solid #f0dfb8; border-radius: 5px; padding: 7px 10px; margin-bottom: 10px; }
  .nfv-tab { width: 100%; border-collapse: collapse; font-size: 12.5px; color: #3b444d; }
  .nfv-tab-carregando { opacity: .55; }
  .nfv-tab th { position: sticky; top: 0; background: #fff; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #8a939c; text-align: left; padding: 6px 8px; border-bottom: 1px solid #e6e9ed; }
  .nfv-tab td { padding: 7px 8px; border-bottom: 1px solid #f0f2f4; vertical-align: top; }
  .nfv-tab tbody tr { cursor: pointer; }
  .nfv-tab tbody tr:hover { background: #f7f9fa; }
  .nfv-tab tbody tr.on { background: #eef4fb; }
  .nfv-tab input { margin: 0; }
  .nfv-nowrap { white-space: nowrap; }
  .nfv-sub { display: block; color: #8a939c; font-size: 11px; }
  .nfv-cel-nome { max-width: 260px; }
  .nfv-cel-nome div, .nfv-cel-compl div { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #1c2024; }
  .nfv-cel-nome small { display: block; color: #8a939c; font-size: 11px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .nfv-cel-compl { max-width: 200px; }
  .nfv-proj-ok { color: #0f8a5f; }
  .nfv-cel-compl div { color: #5b6570; }
  .nfv-dir { text-align: right; white-space: nowrap; }
  .nfv-tag { display: inline-block; font-size: 10.5px; font-weight: 600; border-radius: 9px; padding: 2px 8px; white-space: nowrap; }
  .nfv-tag-cr { background: #e3f3ec; color: #0a6d4d; }
  .nfv-tag-cr .fa { font-size: 8px; vertical-align: 1px; }
  .nfv-tag-sem { background: #f1f3f5; color: #8a939c; }
  .nfv-tag-aberto { background: #fdf3e1; color: #8a5a00; }
  .nfv-tag-baixado { background: #e3f3ec; color: #0a6d4d; }
  .nfv-det-cab { display: flex; justify-content: space-between; gap: 10px; font-size: 15px; color: #1c2024; margin-bottom: 10px; }
  .nfv-dl { margin: 0; font-size: 12.5px; }
  .nfv-dl dt { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #8a939c; margin-top: 8px; }
  .nfv-dl dd { margin: 1px 0 0; color: #1c2024; word-break: break-word; }
  .nfv-dl dd small { color: #6b747e; }
  .nfv-obs { white-space: pre-wrap; max-height: 110px; overflow: auto; color: #3b444d; }
  .nfv-secao { margin-top: 14px; }
  .nfv-secao h5 { margin: 0 0 6px; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #8a939c; }
  .nfv-linha { display: flex; justify-content: space-between; gap: 10px; font-size: 12.5px; color: #1c2024; padding: 2px 0; }
  .nfv-linha-txt { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .nfv-cr { border: 1px solid #e6eaee; background: #fff; border-radius: 5px; padding: 6px 8px; margin-bottom: 6px; }
  .nfv-cr-l2 { display: flex; flex-wrap: wrap; align-items: center; gap: 4px 10px; font-size: 11.5px; color: #6b747e; margin-top: 2px; min-width: 0; }
  .nfv-sem-cr { font-size: 12px; color: #8a939c; }
  .nfv-rodape { display: flex; align-items: center; justify-content: flex-end; gap: 8px; padding: 12px 20px; border-top: 1px solid #e6eaee; flex: 0 0 auto; }
  .nfv-cont { margin-right: auto; font-size: 12px; font-weight: 600; color: #6b747e; padding: 5px 9px; border-radius: 5px; }
  .nfv-ok { background: #eef4fb; color: #2b6cb0; }
  .nfv-bate { background: #e8f5ef; color: #0a6d4d; }
  .nfv-tab tbody tr.marcada { background: #eef7f2; }
  .nfv-sair { display: inline-flex; align-items: center; gap: 7px; background: #fdf1f1; border: 1px solid #e4d7d7; border-radius: 5px; padding: 6px 18px; font-size: 12.5px; font-weight: 600; color: #a13c3c; }
  .nfv-sair:hover { background: #fbe6e6; }
  .nfv-falta { background: #fbeeee; color: #a13c3c; }

  @media (max-width: 860px) {
    .nfv-corpo { flex-direction: column; overflow: auto; }
    .nfv-lista { overflow: visible; }
    .nfv-detalhe { flex: none; border-left: none; border-top: 1px solid #eef1f4; }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/NotaFiscalVinculo.vue